import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBSpecDropDownObjective, DBTextField, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestPositionalTestingCanR extends React.Component {
    handleDiagChange(event) {    
        if (event.target.value !== '1') {
            let fields = ['TSSIDECANNYSTR',
                            'TSSIDECANDURR'
                        ];
                        
            this.props.clearFields(this.props.noteId, 'PTOBJECTIVESPECTESTS', 'TSNO', this.props.tsno, fields);
        }
    }

    render() {
        
        return (
            <div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Positional Testing - Canal R'/>
                    <span className={styles.spacer} />
                    <label className={styles.label}>Sidelying Horizontal Canal - R</label>
                    <DBSpecDropDownObjective
                        field='TSSIDECANR'
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        className={styles.r}
                        optionsValue={1}
                        onChange={(event) => this.handleDiagChange(event)}
                        
                    />
                </div>   
                {this.props.showSpan === true &&                 
                    <span>
                        <div className={styles.textfield_row}>  
                        <span className={styles.spacer} />
                        <span className={styles.spacer} />
                        <span className={styles.spacer} />
                        <label className={styles.label}>Nystagmus Observed</label>
                        <DBSpecDropDownObjective
                        field='TSSIDECANNYSTR'
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        className={styles.r}
                        optionsValue={9}
                    />
                    </div>
                        <div className={styles.textfield_row}>
                        <span className={styles.spacer} />
                        <span className={styles.spacer} />
                        <span className={styles.spacer} />
                        <label className={styles.label}>Duration</label>
                        <DBTextField
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPECTESTS'
                        entityKeyColumn='TSNO'
                        entityKeyValue={this.props.tsno}
                        field='TSSIDECANDURR'
                        className={styles.out_measure_other}
                        />
                    </div>
                    </span>                       
                }
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagged = false;
    let showSpan = false;

    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSSIDECANR == 1) {
        flagged = true;
        showSpan = true;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: flagged,
        showSpan: showSpan
    };
}

const connectedSpecialTestPositionalTestingCanR = connect(mapStateToProps, mapDispatchToProps)(SpecialTestPositionalTestingCanR);
export { connectedSpecialTestPositionalTestingCanR as SpecialTestPositionalTestingCanR };
